import  { useContext } from 'react';
import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import aboutImage from '../../Images/home/about.svg';

const AboutSection = () => {
    const profileInfo = useContext(BioContext);
    const theme = useContext(ThemeContext);
    return ( 
        <section style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
        <h2 className="sectionHeading">LET ME INTRODUCE MYSELF</h2>
        <div className="about">
            <div>
                <img src={aboutImage} alt="about image" className="aboutImage"/>
            </div>
            <div>
                <p>{profileInfo.GeneralInfo.about}</p>
            </div>
            
        </div>
        </section>
     );
}
 
export default AboutSection;